import React, {Component} from 'react'
import Dropzone from 'react-dropzone'
import {Form, Button, Row, Col, InputGroup} from 'react-bootstrap'
import {Field} from "redux-form";


class FileDropzoneField extends Component {

	render() {
		const {
			label,
			feedbackSuccess,
			feedbackIcon,
			input,
			meta: {error, warning, touched},
			sizes,
			fileId,
			fileSrc,
			fileTitle,
			files,
			disabled,
			emptyText,
			valueStyle,
			accept,
			onFileDrop,
			onCancelClick,
			onClearClick,
			onResetClick,
			...props
		} = this.props;

		let message;
		const validationState = touched ? (error && "danger") || (warning && "warning") || (!props.disabled && feedbackSuccess && input.value ? "success" : null) : null;

		if (touched && (error || warning)) {
			message = error || warning
		}

		const dzOptions = {
			multiple: false,
			disablePreview: true
		};
		if (accept) {
			dzOptions.accept = accept
		}

		const f = fileId
			? <InputGroup>
				<div className={"form-control"}>
					<a className="file-placeholder" href={fileSrc} target={'_blank'}><span className="fa fa-file"/> {fileTitle || 'Soubor'}</a>
				</div>
				<InputGroup.Append>
					<Button type="button" variant="warning" onClick={onClearClick}><span className="fa fa-times"/> </Button>
				</InputGroup.Append>
			</InputGroup>
			: <InputGroup>
				<Dropzone onDrop={(acceptedFiles) => onFileDrop(acceptedFiles, input)} ref="dropzone" {...dzOptions}>
					{({getRootProps, getInputProps}) => (
						<div {...getRootProps()} className={"form-control"}>
							<input {...getInputProps()} />
							{files && files[0] && files[0].name
								? <div className="file-placeholder" style={valueStyle}>{files[0].name}</div>
								: <em className="file-placeholder text-muted">({emptyText || 'není'})</em>}
						</div>
					)}
				</Dropzone>
				{!disabled && <InputGroup.Append>
					<Button type="button" variant="info" onClick={() => this.refs.dropzone.open()}><span className="fa fa-file"/> Vybrat</Button>
				</InputGroup.Append>}
				{files && files[0]
					? <InputGroup.Append>
						<Button type="button" variant="warning" onClick={() => onCancelClick(input)} style={{padding: "6px 8px"}}><span className="fa fa-trash"/> </Button>
					</InputGroup.Append>
					: (fileSrc
						? <InputGroup.Append>
							<Button type="button" variant="secondary" onClick={onResetClick}><span className="fa fa-refresh"/> </Button>
						</InputGroup.Append>
						: null)}
			</InputGroup>;

		return message ? <div>{f}
			<div className={"text-" + validationState}>{message}</div>
		</div> : f
	}
}


class FileIdField extends Component {

	render() {
		const {
			label,
			feedbackSuccess,
			buttonLabel,
			feedbackIcon,
			input,
			meta,
			sizes,
			fileSrc,
			fileTitle,
			files,
			disabled,
			emptyText,
			valueStyle,
			accept,
			...props
		} = this.props;

		return <input type={"text"} name={input.name} value={input.value} onChange={input.onChange} {...props}/>
	}
}

export default class FileField extends Component {

	constructor(props) {
		super(props);

		this.onCancelClick = this.onCancelClick.bind(this);
		this.onDrop = this.onDrop.bind(this);

		this.state = {files: []}
	}

	onDrop(filesToUpload, input) {
		this.setState({
			files: filesToUpload
		});

		input.onChange(filesToUpload)
	}

	onCancelClick(input) {
		this.setState({files: []});
		input.onChange({})
	}

	render() {
		const {
			name,
			label,
			buttonLabel,
			sizes,
			fileSrc,
			fileTitle,
			fileContainer,
			formState
		} = this.props;

		const {files} = this.state;

		const labelS = sizes && sizes[0] !== undefined ? sizes[0] : 4;
		const inputS = sizes && sizes[1] !== undefined ? sizes[1] : 8;

		const idField = <Field label={false} name={name} type='text' component={FileIdField}/>;

		const dzField = <Field label={false} name={fileContainer} type='file' component={FileDropzoneField}
			buttonLabel={buttonLabel}
			fileId={formState && formState.values ? formState.values[name] : null}
			fileTitle={fileTitle}
			fileSrc={fileSrc}
			files={files}
			onFileDrop={this.onDrop}
			onCancelClick={this.onCancelClick}
			onClearClick={() => {
				this.props.change(name, null)
			}}
			onResetClick={() => {
				this.props.change(name, formState && formState.initial ? formState.initial[name] : null)
			}}
		/>;

		return (
			<Form.Group as={Row} controlId={name} className={"file-input"}>
				{label && labelS ? <Form.Label column xs={labelS}>{label}</Form.Label> : null}
				<Col xs={inputS}>
					{idField}
					{dzField}
				</Col>
			</Form.Group>
		)
	}
}
